import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Sin protocolo de intervención',
    cost: 'Quedás expuesto cuando el campo se detiene'
  }, {
    without: 'Sin seguimiento documentado',
    cost: 'Cada sesión sin continuidad ni hilo conductor'
  }, {
    without: 'Sin frases sanadoras clasificadas',
    cost: 'Improvisás las palabras más importantes del proceso'
  }, {
    without: 'Sin ficha clínica profesional',
    cost: 'Procesos sin registro que no generan confianza'
  }, {
    without: 'Sin Maestría en Consulta',
    cost: 'Seguís esperando que la profundidad llegue sola'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de improvisación, la próxima semana'
  }];
  return <Section data-id="element-17">
      <div className="text-center mb-12" data-id="element-18"></div>

      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="hidden md:block" data-id="element-20">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-21">
            <div className="font-serif font-bold text-lg text-brand-violet" data-id="element-22">
              Sin Kit Constelaciones
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-23">
              Costo Real
            </div>
          </div>
          <div className="space-y-3" data-id="element-24">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-25">
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-26">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-27">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-28">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-burgundy/10 bg-white/70 space-y-2" data-id="element-29">
              <p className="text-sm font-medium text-brand-text/90" data-id="element-30">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-burgundy/90 font-medium" data-id="element-31">
                <span className="text-brand-burgundy shrink-0" data-id="element-32">→</span>
                <span className="text-sm" data-id="element-33">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-34">
        <p className="text-xl md:text-2xl font-display italic font-[600] text-brand-violetDark" data-id="element-35">
          "El terapeuta que tiene un sistema, trabaja con confianza. El que
          trabaja con confianza, genera resultados. El que genera resultados,
          crece." 🌿
        </p>
      </div>
    </Section>;
};